import { Select } from "@admin/components/atoms/Input";
import { Loading } from "@admin/components/atoms/Loading";
import { Tabs } from "@admin/components/atoms/Tabs";
import { useCompany } from "@admin/hooks/useCompany";
import { useFoodControls } from "@admin/hooks/useFoodControls";
import { useLocationsWithLicenses } from "@admin/hooks/useLocationsWithLicenses";
import { LocationInfo } from "@admin/pages/shift-management/components";
import {
  InstanceStatus,
  LicenseTypes,
  useCommonStore,
} from "@enos-monorepo/lib";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import {
  AllControls,
  LogBook,
  OverDueControls,
  WaitingControls,
} from "./components";
import { MyLists } from "./components/MyLists/MyLists";

export function ControlPointsPage() {
  const { company } = useCompany();
  const { locations, isPending } = useLocationsWithLicenses(LicenseTypes.food);
  const { t } = useTranslation();
  const { setFoodLocation, foodLocation } = useCommonStore();

  const location = useMemo(() => {
    if (foodLocation && locations) {
      return locations.find((l) => l.id === foodLocation) || locations[0];
    }
    return locations && locations.length > 0 ? locations[0] : undefined;
  }, [foodLocation, locations]);

  const { foodControlPoints, controlPoints } = useFoodControls(location);

  if (isPending) {
    return <Loading />;
  }

  return (
    <>
      <div className="flex flex-row rounded-xl bg-white justify-between p-7.5 pb-16 -mb-12">
        <LocationInfo selectedLocation={location} />

        <div className="w-1/4 flex flex-row items-center">
          <Select
            defaultValue={location?.id}
            options={locations?.map((l) => ({ label: l.name, value: l.id }))}
            onChange={(e) => {
              setFoodLocation(e.target.value);
            }}
          />
        </div>
      </div>
      <Tabs
        items={[
          {
            label: t("food.Waiting Controls"),
            content: (
              <WaitingControls
                controls={foodControlPoints.filter(
                  (fc) => fc.status === InstanceStatus.waiting,
                )}
              />
            ),
          },
          {
            label: t("food.All Controls"),
            content: (
              <AllControls
                selectedLocation={location}
                controls={foodControlPoints.filter(
                  (fc) => fc.status !== InstanceStatus.expired,
                )}
                controlPoints={controlPoints}
              />
            ),
          },
          {
            label: t("food.Overdue Controls"),
            content: <OverDueControls selectedLocation={location} />,
          },
          {
            label: t("food.Log Book"),
            content: (
              <LogBook
                selectedLocation={location}
                companyId={company?.companyId}
              />
            ),
          },
          {
            label: t("food.My List"),
            content: <MyLists selectedLocationId={location?.id} />,
          },
        ]}
      />
    </>
  );
}
